export const NEW_AUTHORIZATION_SET_TYPE = 'NEW_AUTHORIZATION_SET_TYPE'
export const NEW_AUTHORIZATION_SET_SPONSOR = 'NEW_AUTHORIZATION_SET_SPONSOR'
export const NEW_AUTHORIZATION_SET_SPONSOR_FORM = 'NEW_AUTHORIZATION_SET_SPONSOR_FORM'
export const NEW_AUTHORIZATION_ERROR = 'NEW_AUTHORIZATION_ERROR'
export const SET_SPONSOR_SEARCH_METHOD = 'SET_SPONSOR_SEARCH_METHOD'
export const SET_INPUTS_SPONSOR_SEARCH_VALUES = 'SET_INPUTS_SPONSOR_SEARCH_VALUES'
export const AUTHORIZATIONS_ERROR = 'AUTHORIZATIONS_ERROR'
export const AUTHORIZATIONS_SUCCESS = 'AUTHORIZATIONS_SUCCESS'
export const AUTHORIZATONS_LOADING = 'AUTHORIZATONS_LOADING'
export const BENEFICIARIES_SUCCESS = 'BENEFICIARIES_SUCCESS'
export const SET_BENEFICIARY_SELECTED = 'SET_BENEFICIARY_SELECTED'
export const SET_BENEFICIARY_SELECTION = 'SET_BENEFICIARY_SELECTION'
export const COMPLETE_TYPE_STEP = 'COMPLETE_TYPE_STEP'
export const COMPLETE_SPONSOR_STEP = 'COMPLETE_SPONSOR_STEP'
export const COMPLETE_METHOD_STEP = 'COMPLETE_METHOD_STEP'
export const COMPLETE_BENEFICIARY_STEP = 'COMPLETE_BENEFICIARY_STEP'
export const COMPLETE_BENEFICIARY_SEARCH = 'COMPLETE_BENEFICIARY_SEARCH'
export const SET_BENEFICIARY = 'SET_BENEFICIARY'
export const FIND_BENEFIRIARY_ERROR = 'FIND_BENEFIRIARY_ERROR'
export const SET_AUTHORIZATION_FORM_VALUES = 'SET_AUTHORIZATION_FORM_VALUES'
export const SET_BIOMETRIC_VERIFICATION_RESULT = 'SET_BIOMETRIC_VERIFICATION_RESULT'
export const SET_LOADING_VERIFICATION = 'SET_LOADING_VERIFICATION'
export const SET_LOADING_CREATE_CLAIM = 'SET_LOADING_CREATE_CLAIM'
export const SET_CREATE_CLAIM_ERROR = 'SET_CREATE_CLAIM_ERROR'
export const SET_NAVBAR_TYPE = 'SET_NAVBAR_TYPE'
export const CLEAR_NEW_AUTHORIZATION = 'CLEAR_NEW_AUTHORIZATION'
export const SET_CREATE_CLAIM_RESULT = 'SET_CREATE_CLAIM_RESULT'
export const AUTHORIZATION_DETAIL_SUCCESS = 'AUTHORIZATION_DETAIL_SUCCESS'
export const AUTHORIZATION_DETAIL_HEADER = 'AUTHORIZATION_DETAIL_HEADER'
export const CLEAR_AUTHORIZATION_DETAIL = 'CLEAR_AUTHORIZATION_DETAIL'
export const DIALOG_AUTHORIZATION_FILES_ATTACH = 'DIALOG_AUTHORIZATION_FILES_ATTACH'
export const AUTHORIZATION_DETAIL_FILE = 'AUTHORIZATION_DETAIL_FILE'
export const AUTHORIZATION_CREATION_BACK_STEP = 'AUTHORIZATION_CREATION_BACK_STEP'
export const AUTHORIZATION_CREATION_NEXT_STEP = 'AUTHORIZATION_CREATION_NEXT_STEP'
export const SET_PRESCRIPTION = 'SET_PRESCRIPTION'
export const CLEAR_AUTHORIZATION_REQUEST_VALUES = 'CLEAR_AUTHORIZATION_REQUEST_VALUES'
export const PRESCRIPTION_CREATED = 'PRESCRIPTION_CREATED'
export const CLEAR_PRESCRIPTION = 'CLEAR_PRESCRIPTION'
export const SET_SPONSOR_PRODUCTS = 'SET_SPONSOR_PRODUCTS'
export const SET_SPONSOR_PRODUCT_DETAIL = 'SET_SPONSOR_PRODUCT_DETAIL'
export const DISPENSING_LOADING = 'DISPENSING_LOADING'
export const DISPENSING_ERROR = 'DISPENSING_ERROR'
export const SET_DISPENSING_COSHARINGS = 'SET_DISPENSING_COSHARINGS'
export const DISPENSATION_CREATION_LOADING = 'DISPENSATION_CREATION_LOADING'
export const SET_COMPLETED_DISPENSATION = 'SET_COMPLETED_DISPENSATION'
export const CLEAR_DISPENSATION = 'CLEAR_DISPENSATION'
export const SET_SPONSORS = 'SET_SPONSORS'
export const SET_PROVIDER_PRODUCT_TYPES = 'SET_PROVIDER_PRODUCT_TYPES'
export const SET_BIOMETRIC_VERIFICATION_REQUIRED = 'SET_BIOMETRIC_VERIFICATION_REQUIRED'
export const SET_FILTERS = 'SET_FILTERS'
export const RESET_BIOMETRIC_VALIDATION = 'RESET_BIOMETRIC_VALIDATION'
export const SET_SPONSOR_DOCUMENT_POLICY = 'SET_SPONSOR_DOCUMENT_POLICY'
export const SET_PROVIDER_INFORMATION = 'SET_PROVIDER_INFORMATION'
export const SET_BIOMETRIC_VERIFICATION_METHOD = 'SET_BIOMETRIC_VERIFICATION_METHOD'
export const SET_SPONSOR_ENABLE_UPDATE_DATA = 'SET_SPONSOR_ENABLE_UPDATE_DATA'
export const SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS = 'SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS'
export const SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR = 'SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR'
